<template>
  <div id="app">

    <transition name="fade">
      <div class="loading"  v-if="showLoading">
        <img src="/img/mappavini-mchapoutier-logo.png" >
      </div>
    </transition>

    <div class="rotate">
      <img src="/img/picto-rotate.png" >
    </div>

    <fullscreen class="fs" ref="fullscreen" @change="fullscreenChange"  >

      <div v-on:click='toggleNavRight()' class="layer_over" style="width: 100%; height: 100%"></div>

      <transition name="fade">
        <div class="transition fadeIn" v-if="showTransition"></div>
      </transition>

      <img src="img/mappavini-mchapoutier-logo.png"  class="logo" alt="">

      <video-player
              class="bg-video"
              ref="videoPlayer"
              :options="playerOptions"
              :playsinline="true"
              customEventName="customstatechangedeventname"
              @playing="onPlayerPlaying($event)"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @loadeddata="onPlayerLoadeddata($event)"
              @timeupdate="onPlayerTimeupdate($event)"
              @statechanged="playerStateChanged($event)"
              @waiting="onPlayerWaiting($event)"
              @ready="playerReadied"
              @canplaythrough="canplaythrough()"
              >
      </video-player>

      <div class="nav-bottom">
        <!-- <div class="legende">
          <p>{{ legende }}</p>
        </div> -->
        <div class="buttons">
          <button v-on:click="toggleMap()"><img src="img/mappavini-mchapoutier-minimap.png"  alt=""></button>
          <button v-on:click="goToIntro()"><img src="img/icons-redemarrer.png" alt=""></button>
          <button v-on:click="toggleFs()"><img src="img/mappavini-mchapoutier-fullscreen-off.png"  alt=""></button>
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://relief.mappavini.com"  onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=700');return false;"><img src="img/pictos-partage-44.png" alt=""></a>
          <a :href="'https://twitter.com/share?url='+sharePath+'&amp;text='+shareText"  onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=700');return false;"><img src="img/pictos-partage-46.png" alt=""></a>
          <a :href="'mailto:?body='+sharePath"><img src="img/mail-white.png" alt=""></a>
        </div>
      </div>

      <div class="titre">
        <h2>La colline de l'Hermitage</h2>
      </div>

      <div class="map"  v-on:click="toggleMap()" v-bind:class="{ open: showMap }">
        <img src="img/mappavini-mchapoutier-map-france.png"  alt="">
      </div>

      <div class="nav-right" v-bind:class="{ open: isNavRightActive }">
        <button class="toggle" v-on:click='toggleNavRight()'><img v-bind:class="{ plop: plopButton }" src="img/mappavini-mchapoutier-left.png"></button>
        <div class="nav-right-content">
          <h3>Hermitage</h3>
          <h2>{{ aoc }}</h2>
          <div class="carousel">
            <!--<button class="prev" v-on:click='toggleNavRight()'> < </button>
            <button class="next" v-on:click='toggleNavRight()'> > </button>-->
            <carousel-3d ref="mycarousel" @before-slide-change="onBeforeSlideChange"
                         @after-slide-change="onAfterSlideChange"
                         @last-slide="onLastSlide"
                         :controlsVisible="true"
                         :width="slider_width" :height="slider_height" :display="nbSlide" :space="spaceSlide" :clickable="isSliderClickable">
              <slide v-for="(parcellaire_image, key) in parcellaire_image_datas" :key='key' :index="key">
                <img :src="'/img/'+parcellaire_image.image" alt="">
              </slide>
            </carousel-3d>
          </div>
          <div class="description">
            <p>{{description}}</p>
          </div>
          <div class="geol">
            {{ geologie_cuvee }}
          </div>
        </div>
      </div>

      <div class="credits">
        &#169;<a href="https://mappavini.com/" title="Mappavini" target="_blank">Mappavini</a>
      </div>

    </fullscreen>

  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import MobileDetect from 'mobile-detect';


export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      parcellaire_image_datas : [
        {
          id : 15,
          video_time_start: 18.9,
          video_time_pause: 22.4,
          video_time_end: 25.5,
          titre: 'Chante-Alouette',
          image : 'labels/chante-alouette.png',
          description : '"Chante-Alouette" est élaboré à partir d\'un cépage unique : La Marsanne, provenant de trois vignobles différents : "Le Méal", "Les Murets" et "Chante-Alouette". Complexe et subtil, un vin emblématique de l\'Hermitage à découvrir.',
          sols_fr: "Loess avec couverture argilo-calcaire"
        },
        {
          id : 9,
          image : 'labels/de-loree.png',
          video_time_start: 46.5,
          video_time_pause: 51,
          video_time_end: 54,
          titre: 'De l\'Orée',
          description : '« Royaume des blancs » sur la colline de l’Hermitage, le Lieu-dit « Les murets » offre des nectars complets et épanouis. Quand ses sols d’argiles lourdes, riches en oxyde de fer, procurent aux vins volume et puissance aromatique, la fraicheur de sa position à l’Est préserve équilibre et complexité. La Marsanne adopte ici des notes de chèvrefeuille, de maïs grillé et des finales aux amers nobles.',
          sols_fr: "Alluvions fluvio-calcaires très anciennes"
        },
        {
          id : 1,
          image : 'labels/le-meal-blanc.png',
          video_time_start: 39.5,
          video_time_pause: 43.9,
          video_time_end: 46.5,
          titre: 'Méal blanc',
          description : 'Ses terrasses de galets et de loess exposées plein sud font de ce coteau abrupt le terroir le plus solaire de l’appellation Hermitage. Avec des baies quasiment rôties au moment de la récolte,  la Marsanne y produit des vins amples aux notes de fruits exotiques, naturellement fumés, avec des nuances de feuille de tomate et de miel d’accacia. Tempérés par la fraicheur des argiles présentes en profondeur, ils n’en restent pas moins complexes et élégants.',
          sols_fr: "Hautes terrasses de galets roulés et d'argiles"
        },
        {
          id : 44,
          image : 'labels/le-meal-rouge.png',
          video_time_start: 32.3,
          video_time_pause: 36.9,
          video_time_end: 39.5,
          titre: 'Méal rouge',
          description : 'Ses terrasses de galets et de loess exposées plein sud font de ce coteau abrupt le terroir le plus solaire de l’appellation Hermitage. La Syrah y atteint de hautes maturités, elle adopte alors des tanins suave, des notes de mures et de délicates nuances fumées caractéristiques. ',
          sols_fr: "Hautes terrasses de galets roulés et d'argiles"
        },
        {
          id : 31,
          image : 'labels/le-pavillon.png',
          video_time_start: 54,
          video_time_pause: 58,
          video_time_end: 61,
          titre: 'Pavillon',
          description : 'Basée sur le coteau des Bessards, mythique pour ses vins rouges, la parcelle du Pavillon se caractérise par des sols de granits faiblement décomposés. Ce terroir à forte personnalité exprime dans les vins des notes de fruits noirs, d’encre de chine et de graphite. Denses, avec des tanins serrés, ces derniers sont prédisposés pour la garde.  ',
          sols_fr: "Fine couche de sédiments reposant sur un sol granitique"
        },
        {
          id : 42,
          image : 'labels/lermite-blanc.png',
          video_time_start: 68,
          video_time_pause: 72,
          video_time_end: 74.5,
          titre: 'Ermite blanc',
          description : 'Au sommet d’un vallon exposé plein Est, en retrait du coteau des Bessards, l’Ermite blanc tire de sa position et de ses sols granitiques peu profonds une fraicheur et une salinité hors du commun. La maturation longue offerte par l’altitude et la douceur du soleil levant permet à la Marsanne d’atteindre de hauts niveaux de complexité, des équilibres ciselés et de fines notes de cailloux frappés. ',
          sols_fr: "Terroirs granitiques très pauvres"
        },
        {
          id : 29,
          image : 'labels/lermite-rouge.png',
          video_time_start: 61,
          video_time_pause: 65,
          video_time_end: 68,
          titre: 'Ermite rouge',
          description : 'Surplombant le mamelon granitique de la colline de l’Hermitage, l’altération de la roche mère donne sur ce terroir des sols meubles mais peu profonds. Le caractère tardif lié à l’altitude de la parcelle permet une maturation des raisins exceptionnellement longue. Il en ressort des vins épurés, racés, complexes et présentant une remarquable tension.',
          sols_fr: "Terroirs granitiques très pauvres"
        },
        {
          id : 71,
          image : 'labels/les-greffieux.png',
          video_time_start: 25.5,
          video_time_pause: 29.9,
          video_time_end: 32.3,
          titre: 'Greffieux',
          description : 'Installé sur les premiers pends de coteaux au pied du Méal, ce terroir d’alluvions fluviatiles récents fait partie des sols sédimentaires emblématiques de la colline de L’Hermitage. Quand la chaleur restituée par galets blancs de surface procure concentration et expression au vin, les argiles profondes apportent finesse et persistance aromatique. ',
          sols_fr: "Terrasse d'alluvions glaciaires composée de galets roulés et d'argiles"
        },
        {
          id : 46,
          image : 'labels/sizeranne.png',
          video_time_start: 11.9,
          video_time_pause: 15.8,
          video_time_end: 18.5,
          titre: 'Monier de La Sizeranne',
          description : 'La cause des aveugles et des malvoyants a été un sujet de dévotion pour Maurice Monier de la Sizeranne au 19ème siècle : cet illustre personnage de Tain l\'Hermitage a consacré toute sa vie à la cause des aveugles en développant l\'écriture braille abrégée. "Monier de la Sizeranne"est un Hermitage rond, élégant, aux tanins concentrés et souples.',
          sols_fr: "Assemblage de différents terroirs : granit, limons, alluvions"
        }
      ],
      isNavRightActive : false,
      playerOptions: {
        // videojs options
        autoplay: false,
        muted: true,
        controls: false,
        /*preload: 'auto',*/
        sources: [
          {
            type: "video/webm",
            src: "m-chapoutier-animation.webm"
          },
          {
            type: "video/mp4",
            src: "m-chapoutier-animation.mp4"
          }
        ],
      },
      slider_height : 400,
      slider_width : 120,
      aoc : '',
      cuvee : '',
      description : '',
      geologie_cuvee : '',
      sharePath : 'https://chapoutier.mappavini.com',
      shareText : 'La colline d\'Hermitage en relief 3D Découvrez les Hermitages de la Maison M. Chapoutier dans leur parcelle d\'origine et les secrets de chaque micro-terroir.\n' +
              '@M_Chapoutier @MappaVini #hermitage #syrah #marsanne #roussanne #terroir #rhonevalley #winelover',
      all_timecodes: [],
      next_stop: 0,
      current_index:0,
      in_transition: false,
      showMap: false,
      firstTimeOpenSideMenu: true,
      showTransition: false,
      showLoading: true,
      plopButton: true,
      nbSlide: 5,
      spaceSlide: 100,
      isSliderClickable: true,
      firstAnimation: true,
      mb: null
    }
  },
  mounted() {

    this.md = new MobileDetect(window.navigator.userAgent);

    if(this.md.mobile()){
      this.nbSlide = 3
      this.spaceSlide = 50
    }

    console.log("screen.height", screen.height)
    console.log("screen.width", screen.width)
    console.log("window.innerHeight", window.innerHeight)

    var supportsOrientationChange = "onorientationchange" in window,
            orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";

    window.addEventListener("resize", () => {

      if(this.md.mobile()){
        if(screen.height < screen.width ) {
          this.player.play();
          this.slider_height = (window.innerHeight*50)/100;
          this.slider_width = (this.slider_height*12)/40;
        }else{
          this.player.pause();
        }
      }

    }, false);

    this.slider_height = (window.innerHeight*50)/100;
    this.slider_width = (this.slider_height*12)/40;
    this.parcellaire_image_datas.forEach( data => {
      this.all_timecodes.push(data.video_time_start);
      this.all_timecodes.push(data.video_time_pause);
      this.all_timecodes.push(data.video_time_end);
    })

    // INIT MAP
    this.next_stop = 11;
    this.aoc = this.parcellaire_image_datas[0].titre;
    this.cuvee = this.parcellaire_image_datas[0].titre;
    this.description = this.parcellaire_image_datas[0].description;
    this.geologie_cuvee = this.parcellaire_image_datas[0].sols_fr;
    this.cuvee = this.parcellaire_image_datas[0].sols_fr;
    this.current_index = 0;
    this.in_transition = false;

  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    // listen event
    onPlayerTimeupdate(event) {

      if(this.player.currentTime() > this.next_stop){
        if(this.in_transition) {
          // this.showTransition = true;
          this.player.currentTime(this.parcellaire_image_datas[this.current_index].video_time_start);
          this.next_stop = this.parcellaire_image_datas[this.current_index].video_time_pause;
          this.in_transition = false
        }else{
          this.showTransition = false;
          this.isSliderClickable = true;
          this.player.pause();
          if(this.firstAnimation){
            this.firstAnimation = false;
            /*setTimeout(() => {
              this.next_stop = 8.5;
              this.player.play();
            }, 3000)*/
          }
        }

      }
    },
    onPlayerPlaying(event) {
      console.log('onPlayerPlaying', event)
      this.showLoading = false;
      //console.log("event", this.player.currentTime)
      },
    onPlayerPlay(player) {
      console.log('onPlayerPlay', player)
      this.showLoading = false;
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    onPlayerLoadeddata(event){
      console.log('onplayeloaderdad', event)
      this.showLoading = false;

      if(this.md.mobile()){
        if( screen.height < screen.width ) {
          this.player.play();
        }
      }else{
        this.player.play();
      }
    },
    onPlayerWaiting(event){
      // console.log('onPlayerWaiting', event)
    },
    // player is ready
    playerReadied(player) {
      console.log("player ready", this.player)
      console.log("player ready", player)
      this.showLoading = false;
      player.play();
      // this.watchloop()


      //console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    canplaythrough(){
      // console.log("CAN PLAY TROUGH")
    },
    onAfterSlideChange(index) {

      //if((index - this.current_index) == 1){
      if(!this.in_transition) {
        this.player.currentTime(this.parcellaire_image_datas[this.current_index].video_time_pause);
        this.next_stop = this.parcellaire_image_datas[this.current_index].video_time_end

        // INFOS
        this.aoc = this.parcellaire_image_datas[index].titre;
        this.description = this.parcellaire_image_datas[index].description;
        this.geologie_cuvee = this.parcellaire_image_datas[index].sols_fr;
        this.current_index = index;
        this.in_transition = true;
        this.player.play();
        this.isSliderClickable = false;
      }
    },
    goToIntro(){
      //this.player.currentTime(0);
      // this.player.play();
      this.showLoading = true;
      this.$refs.mycarousel.goSlide(0);
      this.current_index = 0;
      this.in_transition = true;
      setTimeout(() => {
        this.player.currentTime(0);
        this.next_stop = 11;
        this.player.play();
        this.showLoading = false;
        this.isNavRightActive = false;
        this.firstTimeOpenSideMenu = true;
        this.in_transition = false
      }, 2000)
    },
    onLastSlide(index) {

    },
    onBeforeSlideChange(index) {
      //

      //}
      //this.$refs.mycarousel.clickable = false;


      /*
      this.player.currentTime(this.parcellaire_image_datas[index].video_time_start);
      this.next_stop = this.parcellaire_image_datas[index].video_time_pause
      this.player.play();

      */

      /*var data_parc = this.parcellaire_data.find((ld) => {
        return ld.label == this.parcellaire_image_datas[index].image
      });

      if(data_parc){

        this.aoc = data_parc.aoc;
        this.cuvee = data_parc.cuvee;
        this.description = this.parcellaire_image_datas[index].description
        this.legende =  data_parc.cuvee + ' | ' + data_parc.leg_fr;
        this.geologie_cuvee = data_parc.sols_fr;
        this.isNavRightActive = true;

        /!* // find index of slide
        let idx_photo = this.findWithAttr(this.parcellaire_image_datas, 'image', data_parc[0].label)

        this.$refs.mycarousel.goSlide(idx_photo) *!/
      }*/
    },
    toggleNavRight() {
      this.plopButton = false
      if(this.isNavRightActive) {
        this.isNavRightActive = false;
      } else {
        if(this.firstTimeOpenSideMenu) {
          this.firstTimeOpenSideMenu = false;
          this.player.currentTime(this.parcellaire_image_datas[0].video_time_start);
          this.next_stop = this.parcellaire_image_datas[0].video_time_pause;
          this.player.play();
        }
        this.isNavRightActive = true;
      }

    },
    toggleMap() {

      if(this.showMap){
        this.showMap = false;
      } else {
        this.showMap = true;
      }

    },
    toggleFs () {
      this.$refs['fullscreen'].toggle() // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange (fullscreen) {
      // this.fullscreen = fullscreen
    },
    watchloop(){
      requestAnimationFrame(this.watchloop)
      // console.log("buffer percent", this.player.bufferedPercent())
    }
  }
}
</script>

<style lang="scss">
  *:focus {
    outline: none;
  }

  button::-moz-focus-inner {
    border: 0;
  }

  #app {
    font-family: 'Bree Serif', serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
    position: relative;
    display: block;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    overflow: hidden;
    height: 100%;
    max-width: 100%;
  }

  h1, h2, h3, h4, h5, h6{
    font-family: 'Cinzel', serif;
    margin: 0;
  }

  button{
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    outline: none;
  }
  .credits{
    z-index: 2;
    color: white;
    bottom: 0.4rem;
    left: 0.4rem;
    position: absolute;
    font-size: 0.5rem;
    opacity: 0.8;
  }
  .credits a{
    color: white;
    text-decoration: none;
  }
  .layer_over{
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    z-index: 2;
  }

  .logo{
    position: absolute;
    top:4vw;
    left:4vw;
    width: 15vw;
    z-index: 2;
  }

  .loading{
    z-index: 5000;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /*background-image: url("/img/hermitage-chapelle-min.jpg");*/
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background: linear-gradient(
                    rgba(0,0,0, .5),
                    rgba(20,20,20, .5)), url("/img/hermitage-chapelle-min.jpg");
   /* width: 100vw;
    height: 100vh;*/
  }


  .bg-video{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
  }

  .bg-video .video-js{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg-video video{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }


  .nav-bottom{
    position: absolute;
    z-index: 2;
    bottom:0;
    left: 0;
    width: 100vw;
    height: 5vh;
  }

  .legende{
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 30vw;
    height: 8vh;
    color: #fff;
    text-align: left;
    display: flex;
    align-items: center;

  }

  .legende p{
    margin-left: 1vw;
  }

  .titre{
    position: absolute;

    bottom: 6vh;
    height: 9vh;
    border-radius: 4px;
    color: #fff;
    margin: 0 auto;
    width: 22vw;
    left: 39vw;
    font-size: 0.9em;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .titre h2{
    font-weight: normal;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 0.5rem;
  }

  .buttons{
    background-color: rgba(0, 0, 0, 0.5);
    width: 18vw;
    height: 5vh;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .buttons button{
    width: 5vh;
    padding: 1vh;
    display: inline-block;
  }

  .buttons a{
    width: 3vh;
    padding: 1vh;
    display: inline-block;
  }

  .nav-bottom button img, .nav-bottom a img{
    width: 100%;
  }

  .nav-right{
    color: #fff;
    position: absolute;
    width: 30vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    right: -30vw;
    transition:right 0.5s linear;
    z-index: 2;
    /*overflow: scroll;*/
  }
  .plop{
    text-decoration: blink;
    animation: Test 1s infinite;
  }
  @keyframes Test{
    0%{opacity: 1;}
    50%{opacity: 0;}
    100%{opacity: 1;}
  }
  .nav-right h2{
    font-weight: normal;
    font-size: 2em;
    height: 10vh;
  }

  .nav-right h3{
    font-weight: normal;
    margin-top: 2vw;
  }

  .nav-right.open{
    right: 0;
  }

  .carousel{
    /* height: 400px; */
    .next, .prev{
      color: rgba(255,255,255,0.5);
      span{
        color: rgba(255,255,255,0.5);
      }
    }
  }

  .carousel img{
    object-fit: cover;
  }

  .carousel .carousel-3d-slide{
    background: transparent;
    border: none;
  }

  .nav-right .toggle{
    position: absolute;
    left: -35px;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    top: 5vh;
    width: 35px;
    height: 55px;
    background: rgba(0, 0, 0, 0.5);
    /*border-radius: 35px 0 0 35px;*/
    border-radius: 6px 0 0 6px;
  }

  .nav-right .toggle img{
    height:1.8vw;
  }

  .nav-right.open .toggle img{
    transform: rotate(180deg);
  }

  .nav-right .description{
    text-align: left;
    padding: 0 2vw;
    font-size: 0.9rem;
  }

  .nav-right .description p{
    margin: 0
  }
  .nav-right .geol{
    background: rgba(255, 255, 255, 0.5);
    color: #333;
    padding: 2vh;
    margin: 2vh;
    font-size: 0.9rem;
  }

  .map{
    display: none;
    text-align: center;
    position: fixed;
    top: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0,0,0, 0.5);
    z-index: 3;

  }

  .map img{
    width: 80vw;
  }
  .map.open{
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .transition{
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: white;

    opacity: 0;

  }

  .fadeIn{
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 2s;
  }



  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }


  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .fullscreen{
    overflow: hidden;
  }

  .rotate{
    z-index: 5000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    /*background: white;*/
    display: none;
    padding: 5rem;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-image: url("/img/hermitage-chapelle-min.jpg");
    background-size: cover;
    background-position: center;

  }
  .rotate img{
    width: 100%;
    height: auto;
  }

  .nav-right-content{
    overflow-y: scroll;
    height: 100%;
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) {

    .nav-right h2{
      font-size: 1em;
    }
    .titre h2{
      font-size: 0.6em;
    }
    .buttons{

    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 577px) and (max-width: 768px) {
    .nav-right h2{
      font-size: 1em;
    }
    .titre{
      left: 35vw;
      bottom: 12vh;
      width: 30vw;
    }
    .titre h2{
      font-size: 0.9em;
    }
    .nav-bottom{
      height: 10vh;
    }
    .buttons{
      width: 30vw;
      height: 10vh;
    }
    .buttons button{
      width: 10vh;
    }
    .buttons a{
      width: 8vh;
    }
    .nav-right .description{
      max-height: unset;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 769px){
    .titre h2{
      font-size: 1.2em;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
    .rotate {
      display: flex;
    }
  }

</style>
